import { z } from 'zod';
import { AccountIdSchema } from './accounts';
import { NumericalIdSchema } from './commonTypes';
export var ProductIdSchema = NumericalIdSchema;
export var ProductSchema = z.object({
    id: ProductIdSchema,
    account_id: AccountIdSchema,
    product_name: z.string(),
    deactivated: z.boolean(),
    add_time: z.string(),
    update_time: z.string(),
    value_required: z.boolean(),
    value_label: z.string().nullable(),
    // Backend sends boolean but legacy code expects number (0/1)
    memo_required: z.union([z.boolean(), z.number()]).optional()
});
// Makes all attributes optional except for id and product_name
export var AddProductSchema = ProductSchema.partial().required({
    id: true,
    product_name: true
});
